<template>
    <div>
        <div class="w-100 d-flex container py-3" :class="row.sticky ? 'sticky-top' : ''">
            <Container :should-accept-drop="shouldAcceptDrop" orientation="horizontal"
                       class="d-flex flex-grow-1 align-items-center column-border" tag="div"
                       :get-child-payload="getBlock1Payload"
                       @drop="onBlock1Drop('navItems', $event)" style="min-height: 44px;">

                <Draggable v-for="(component, columnIndex) in block1.value" :key="'navBlock1' + columnIndex">
                        <element-container :component="component" :column="block1"
                                           class="position-relative"
                                           :layout="layout" :key="componentKey(columnIndex) + '1'"
                                           @iconClick="onEditIcon"
                                           @imageClick="onEditImage"></element-container>
                </Draggable>

            </Container>

            <Container v-if="block2 !== null" :should-accept-drop="shouldAcceptDrop" orientation="horizontal"
                       class="d-flex align-items-center justify-content-end column-border" tag="div"
                       :get-child-payload="getBlock2Payload"
                       @drop="onBlock2Drop('navItems', $event)" style="min-height: 44px;">

                <Draggable v-for="(component, columnIndex) in block2.value" :key="'navBlock2' + columnIndex">
                    <element-container :component="component" :column="block2"
                                       class="position-relative"
                                       :layout="layout" :key="componentKey(columnIndex) + '2'"
                                       @iconClick="onEditIcon"
                                       @imageClick="onEditImage"></element-container>
                </Draggable>
            </Container>
        </div>

        <icon-modal v-if="showIconModal" @noEvent="showIconModal = false"
                    :yesEvent="iconSelected"></icon-modal>

        <image-modal v-if="showImageModal" @noEvent="showImageModal = false" :website="model.website"
                     :yesEvent="imageSelected" key="navImageModal"></image-modal>
    </div>
</template>

<script>
import {Container, Draggable} from "vue3-smooth-dnd"
// import Container from "../../components/draganddrop/components/Container";
// import Draggable from "../../components/draganddrop/components/Draggable";
import PageFactory from "../../utils/PageFactory";
import ImageModal from "./ImageModal.vue";
import IconModal from "./IconModal.vue";
import ElementContainer from "./ElementContainer.vue";
import RowContainer from "../view/RowContainer.vue";
import {applyDrag} from "../../utils/DragUtils"

export default {
    name: 'NavRendererPlus',
    props: ['layout'],
    components: {
        RowContainer,
        ImageModal,
        IconModal,
        ElementContainer,
        Container,
        Draggable
    },
    data() {
        return {
            model: webase.model,
            isMouseOver: false,
            pageFactory: new PageFactory(),
            showIconModal: false,
            iconSelected: function (icon) {
            },
            showImageModal: false,
            imageSelected: function (image) {
            }
        }
    },
    computed: {
        row() {
            return this.layout.rows[this.layout.rows.length - 1]
        },
        bannerRow() {
            return this.layout.rows[0]
        },
        hasBanner() {
            return this.layout.rows.length == 2
        },
        rowStyle() {
            return {
                backgroundColor: this.row.background && this.row.background.color ? this.row.background.color : '#FFFFFF'
            }
        },
        navClasses() {
            let cssClasses = ''

            if (this.row.shadow) {
                cssClasses += ' shadow'
            }

            if (this.row.justify && this.row.justify === 'right') {
                cssClasses += ' justify-content-end'
            }

            return cssClasses.trim()
        },
        leftNavClasses() {
            let cssClasses = this.block2 ? 'w-50' : 'w-100'

            if (this.row.justify && this.row.justify === 'right') {
                cssClasses += ' justify-content-end'
            } else {
                cssClasses += ' justify-content-start'
            }

            return cssClasses.trim()
        },
        firstComponent() {
            if (this.block1.value.length > 0) {
                return this.block1.value[0]
            }

            return null
        },
        block1() {
            return this.row.columns[0]
        },
        block2() {

            if (this.row.columns.length === 2) {
                return this.row.columns[1]
            }

            return null
        }
    },
    mounted() {
        if (!this.row.justify) {
            this.row.justify = 'left'
        }
    },
    methods: {
        onEditIcon() {
            this.showIconModal = true
            this.iconSelected = (icon) => {
                this.layout.selectedComponent.value = icon
            }
        },
        onEditImage() {
            this.showImageModal = true
            this.imageSelected = (image) => {
                this.layout.selectedComponent.value = image
            }
        },
        componentKey(columnIndex) {
            return 'navCompEditor-' + this.index + columnIndex
        },
        getBlock1Payload(index) {
            return this.block1.value[index]
        },
        getBlock2Payload(index) {
            return this.block2.value[index]
        },
        onBlock1Drop(collection, dropResult) {
            if( this.block1.value.includes(dropResult.payload) ) {
                this.block1.value = applyDrag(this.block1.value, dropResult)
                return
            }
            this.onDrop(collection, dropResult, this.block1)
        },
        onBlock2Drop(collection, dropResult) {

            if( this.block2.value.includes(dropResult.payload) ) {
                this.block2.value = applyDrag(this.block2.value, dropResult)
                return
            }

            this.onDrop(collection, dropResult, this.block2)
        },
        onDrop(collection, dropResult, column) {

            if (dropResult.addedIndex === null) {
                return
            }

            let payload = dropResult.payload

            if (payload.type === 'Icon') {
                this.showIconModal = true
                this.iconSelected = (icon) => {
                    let iconComponent = this.pageFactory.createIconComponent(icon)
                    // this.setLabelColor(iconComponent)
                    column.value.push(iconComponent)
                    this.layout.selectedComponent = column.value[column.value.length - 1]
                }

                return
            } else if (payload.type === 'Image') {
                this.showImageModal = true
                this.imageSelected = (image) => {
                    let imageComponent = this.pageFactory.createImageComponent(image)
                    column.value.push(imageComponent)
                    this.layout.selectedComponent = column.value[column.value.length - 1]
                }

                return
            }

            // this.setLabelColor(payload)
            column.value.push(payload)
            this.layout.selectedComponent = column.value[column.value.length - 1]
        },
        shouldAcceptDrop(sourceContainerOptions, payload) {
            console.log('nav plus accept drop')
            console.log(sourceContainerOptions)
            return sourceContainerOptions.groupName !== "rowContainers"
        },
    }
}
</script>
